module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-sad.f77425cd.png";